// Les flèches ← → du clavier changent le jour du planning, sauf quand l'utilisateur
// est dans un champ (le curseur doit bouger dans le texte) ou qu'une modale est
// ouverte par-dessus : le jour du planning derrière changeait pendant la saisie.
export function planningArrowsAllowed(e: KeyboardEvent): boolean {
  if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return false;
  const t = e.target as HTMLElement | null;
  if (t && (t.isContentEditable || ["INPUT", "TEXTAREA", "SELECT"].includes(t.tagName))) return false;
  if (typeof document !== "undefined" && document.querySelector('[data-modal-open], [role="dialog"]')) return false;
  return true;
}
